import Demo from './demo';

export default Demo;
